<template>
    <tr :class="{'yellow lighten-3': !saved && !value.invoice_number, 'green lighten-4' : saved}">
        <td style="width: 140px">
            <v-text-field dense solo type="number" label="Kundenr." v-model="value.customer_number"
                          hide-details class="my-1" :disabled="value.has_customer_number"/>
        </td>
        <td>
            <router-link :to="{name: 'CustomerShow', params: {id: value.customer_id}}" v-if="!value.customer_archived">
                {{ value.customer_name }}
            </router-link>
            <span v-else>{{ value.customer_name }}</span>
            <span class="red--text pl-2" v-if="value.customer_archived">(arkivert)</span>
        </td>
        <td>
            <router-link :to="{name: 'CarShow', params: {id: value.car_id}}">
                {{ value.reg_number }}
            </router-link>
            <br>
            <small>{{ value.car_type }}</small>
        </td>
        <td>
            <TireTypeIcon :value="type" v-for="type in value.tire_types" :key="type" class="mr-1" :title="tireDates"/>
        </td>
        <td>
            <div v-if="value.previous_date && value.date !== value.previous_date">
                <small class="d-block">Sist fakturert</small>
                {{ formattedPrevDate }}
            </div>
        </td>
        <td style="width: 160px" class="px-1">
            <v-text-field dense solo type="date" label="Fakturadato" v-model="value.date"
                          hide-details class="my-1"/>
        </td>
        <td style="width: 200px" class="px-1">
            <v-text-field dense solo type="text" label="Fakturanr." v-model="value.invoice_number"
                          hide-details class="my-1"/>
        </td>
        <td style="width: 120px">
            <v-btn block text color="primary" @click="save" :loading="saving">
                <v-icon left>save</v-icon>
                Lagre
            </v-btn>
        </td>
    </tr>
</template>

<script>
import TireTypeIcon from "@/components/helpers/TireTypeIcon";
import moment from "moment";

export default {
    components: {
        TireTypeIcon
    },
    props: {
        value: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            saving: false,
            saved: this.value.invoice_number
        }
    },
    methods: {
        save() {
            let request;

            let data = {
                customer_number: this.value.customer_number,
                invoice_number: this.value.invoice_number,
                date: this.value.date,
            }

            if (this.value.id) request = this.$http.put(`invoicing/${this.value.car_id}/${this.value.id}`, data);
            else request = this.$http.post(`invoicing/${this.value.car_id}`, data);

            this.saving = true;

            request.then(response => {
                let storedInvoice = response.data.data;
                this.value.id = storedInvoice.id;
                Object.keys(storedInvoice).forEach(key => {
                    this.value[key] = storedInvoice[key];
                });
                this.saved = true;
            }).catch(() => {
                this.$root.addMessage('Kunne ikke lagre fakturanummer.', 'red');
            }).finally(() => {
                this.saving = false;
            });

        }
    },

    computed: {
        tireDates() {
            let s = [];
            this.value.tire_periods.forEach(period => {
                s.push(`${period.in_at} - ${period.out_at ? period.out_at : 'neste fakturaperiode'}`);
            })
            return s.join('\n');
        },

        formattedPrevDate() {
            return moment(this.value.previous_date).format('ll');
        }
    },
}
</script>

<style scoped>

</style>
